'use strict';
const angular = require('angular');
const {copy, isFunction, isObject, isString, isUndefined/*, noop*/} = angular;

export function DomainCollectionProvider() {
  return {
    $get: [
      '$injector',
      '$exceptionHandler',
      '$q',
      '$cacheFactory',
      'FirebaseUtil',
      'FirebaseObjectFactory',
      '$domain',
      'DomainBootstrapper',
      '$$DomainUtilities',
      function (
        $injector,
        $exceptionHandler,
        $q,
        $cacheFactory,
        FirebaseUtil,
        FirebaseObjectFactory,
        $domain,
        DomainBootstrapper,
        DomainUtilities,
      ) {
        function DomainCollection(Class, listName, config) {
          Object.defineProperties(this, {
            $$class: {value: Class},
            $$config: {value: config},

            $$linkClassName: {value: config.domainClass},
            $$link: {value: config.link},
            $$listName: {value: listName},

            $$relationClassName: {value: config.relationClass}
          });

          DomainBootstrapper.queue(init.bind(this))
        }

        DomainCollection.prototype.getFirstItem = getFirstItem;
        DomainCollection.prototype.getFirstRelation = getFirstRelation;
        DomainCollection.prototype.getItems = getItems;
        DomainCollection.prototype.getSubLinkItems = getSubLinkItems;
        DomainCollection.prototype.getAllItems = getAllItems;
        DomainCollection.prototype.getRelations = getRelations;
        DomainCollection.prototype.getSubLinkRelations = getSubLinkRelations;
        DomainCollection.prototype.getRelation = getRelation;
        DomainCollection.prototype.getRelationRef = getRelationRef;
        DomainCollection.prototype.getAllRelations = getAllRelations;
        DomainCollection.prototype.addItem = DomainUtilities.intercepted(addItem);
        DomainCollection.prototype.removeItem = DomainUtilities.intercepted(removeItem);

        function isItem() {

        }

        function isRelation() {

        }

        function getFirstItem(id) {
          var LinkClass = this.$$linkClass;
          return this.getFirstRelation(id).then(function (relation) {
            if (isObject(relation)) {
              return LinkClass.$get(relation.$id);
            } else {
              return LinkClass.$get(relation);
            }
          });
        }

        function getFirstRelation(id) {
          var RelationClass = this.$$relationClass;
          var result, deferred = $q.defer();

          var ref = FirebaseUtil.firebaseRef($domain.relationPath(this.$$class.COLLECTION, id, this.$$listName));

          ref.once('child_added', function onRelationChildAdded(ss) {
            if (RelationClass) {
              result = RelationClass.$factory.create(ss.key());
              result.$loaded().then(function () {
                deferred.resolve(result);
              })
            } else {
              result = ss.key();
              deferred.resolve(result);
            }
          });
          return deferred.promise;
        }

        function getItems(id) {
          var result;
          var cacheName = this.$$class.COLLECTION + '-meta/';
          var cacheId = id + '/links/' + this.$$listName + '-List';
          var cache = $cacheFactory.get(cacheName) || $cacheFactory(cacheName);

          result = cache.get(cacheId);

          if (!result) {
            result = new FirebaseObjectFactory({
              ref: FirebaseUtil.firebaseRef(this.$$linkCollection),
              factory: this.$$linkClass.$factory,
              factoryMethodName: 'create',
              filters: [this.getRelations(id)]
            });
            //console.log('DomainCollection.getItems(' + id + '): creating cache(' + cacheName + ') id(' + cacheId + ')', result);
            cache.put(cacheId, result);

            //var originalDestroy = isFunction(result.$destroy) ? result.$destroy.bind(result) : noop;
            //
            //Object.defineProperty(result, '$destroy', {
            //  configurable: true,
            //  write: true,
            //  value: function $destroy() {
            //    originalDestroy();
            //    cache.remove(cacheId);
            //  }
            //});
          }

          return result;
        }

        function getSubLinkItems(linkId, sublinkId) {
          var result;
          var cacheName = this.$$class.COLLECTION + '-meta/';
          var cacheId = linkId + '/links/' + this.$$listName + '/' + sublinkId + '-List';
          var cache = $cacheFactory.get(cacheName) || $cacheFactory(cacheName);

          result = cache.get(cacheId);

          if (!result) {
            result = new FirebaseObjectFactory({
              ref: FirebaseUtil.firebaseRef(this.$$linkCollection),
              factory: this.$$linkClass.$factory,
              factoryMethodName: 'create',
              filters: [this.getSubLinkRelations(linkId, sublinkId)]
            });
            cache.put(cacheId, result);
          }

          return result;
        }

        function getRelations(id) {
          var result;
          var cacheName = this.$$class.COLLECTION + '-meta/';
          var cacheId = id + '/links/' + this.$$listName + '-Relations';
          var cache = $cacheFactory.get(cacheName) || $cacheFactory(cacheName);

          result = cache.get(cacheId);

          if (!result) {
            if (this.$$relationClass) {
              result = new FirebaseObjectFactory({
                ref: FirebaseUtil.firebaseRef($domain.relationPath(this.$$class.COLLECTION, id, this.$$listName)),
                factory: this.$$relationClass.$factory,
                factoryMethodName: 'create'
              });
            } else {
              result = new FirebaseObjectFactory(FirebaseUtil.firebaseRef($domain.relationPath(this.$$class.COLLECTION, id, this.$$listName)));
            }
            //console.log('DomainCollection.getRelations(' + id + '): creating cache(' + cacheName + ') id(' + cacheId + ')', result);
            cache.put(cacheId, result);

            //var originalDestroy = result.$destroy.bind(result);
            //
            //Object.defineProperty(result, '$destroy', {
            //  configurable: true,
            //  write: true,
            //  value: function $destroy() {
            //    originalDestroy();
            //    cache.remove(cacheId);
            //  }
            //});
          }

          return result;
        }

        function getSubLinkRelations(linkId, sublinkId) {
          var result;
          var cacheName = this.$$class.COLLECTION + '-meta/';
          var cacheId = linkId + '/links/' + this.$$listName + '/' + sublinkId + '-Relations';
          var cache = $cacheFactory.get(cacheName) || $cacheFactory(cacheName);

          result = cache.get(cacheId);

          if (!result) {
            var ref = FirebaseUtil.firebaseRef($domain.relationPath(this.$$class.COLLECTION, linkId, this.$$listName) + '/' + sublinkId);

            if (this.$$relationClass) {
              result = new FirebaseObjectFactory({
                ref: FirebaseUtil.firebaseRef(ref),
                factory: this.$$relationClass.$factory,
                factoryMethodName: 'create'
              });
            } else {
              result = new FirebaseObjectFactory(ref);
            }
            cache.put(cacheId, result);
          }

          return result;
        }

        function getRelation(id, linkId) {
          var RelationClass = this.$$relationClass;
          return FirebaseUtil.read($domain.relationPath(this.$$class.COLLECTION, id, this.$$listName) + '/' + linkId).then(function (relation) {
            if (!relation) {
              return null;
            } else if (!RelationClass) {
              return relation;
            } else {
              return RelationClass.$factory.create(relation);
            }
          });
        }

        function getRelationRef(id, linkId) {
          return FirebaseUtil.firebaseRef($domain.relationPath(this.$$class.COLLECTION, id, this.$$listName) + '/' + linkId);
        }

        function getAllRelations(id) {
          var RelationClass = this.$$relationClass;
          return FirebaseUtil.read($domain.relationPath(this.$$class.COLLECTION, id, this.$$listName)).then(function (relations) {
            if (!relations) {
              return null;
            } else if (!RelationClass) {
              return relations;
            } else {
              var results = {};
              for (var linkId in relations) {
                if (relations.hasOwnProperty(linkId)) {
                  results[linkId] = RelationClass.$factory.create(relations[linkId]);
                }
              }
              return results;
            }
          });
        }

        function getAllItems(id) {
          var linkClass = this.$$linkClass;
          return FirebaseUtil.read($domain.relationPath(this.$$class.COLLECTION, id, this.$$listName)).then(function (relations) {
            if (!relations) {
              return null;
            } else {
              var promises = {};
              for (var linkId in relations) {
                if (relations.hasOwnProperty(linkId)) {
                  promises[linkId] = linkClass.$get(linkId);
                }
              }
              return $q.all(promises);
            }
          });
        }

        function addItem(id, foreignId, value) {
          if (isObject(foreignId)) foreignId = foreignId.$id;
          //console.log('calling ' + Class.name + '$addTo' + methodStub + ' id:' + id + ' foreignId:' + foreignId + ' value:' + value);
          if (isUndefined(foreignId) || foreignId === null) {
            throw new Error('Called $addTo' + this.methodStub + ' on class ' + this.$$class.$name + ' with null foreignId!');
          }
          if (isUndefined(value) || value === null) value = true;
          return FirebaseUtil.set($domain.relationPath(this.$$class.COLLECTION, id, this.$$listName, foreignId), value);
        }

        function removeItem(id, foreignId) {
          if (isObject(foreignId)) foreignId = foreignId.$id;
          //console.log('calling ' + Class.name + '$removeFrom' + methodStub + ' id:' + id + ' foreignId:' + foreignId);
          if (isUndefined(foreignId) || foreignId === null) {
            throw new Error('Called removeFrom' + this.methodStub + ' on class ' + this.$$class + ' with null foreignId!');
          }
          return FirebaseUtil.remove($domain.relationPath(this.$$class.COLLECTION, id, this.$$listName, foreignId));
        }

        function init(injector) {
          var Class = this.$$class;
          var LinkClass = injector.get(this.$$linkClassName);
          var linkCollection = LinkClass.COLLECTION;
          var RelationClass = isString(this.$$relationClassName) ? injector.get(this.$$relationClassName) : null;
          var listName = this.$$listName;
          var linkField = this.$$link;

          Object.defineProperties(this, {
            $$linkClass: {value: LinkClass},
            $$linkCollection: {value: linkCollection},

            $$listName: {value: listName},
            $$relationClass: {value: RelationClass}
          });

          var methodStub = this.methodStub = DomainUtilities.camelCase(listName.charAt(0).toUpperCase() + listName.substring(1));

          if (linkField && !LinkClass.$constraints.hasOwnProperty(linkField)) {
            throw new Error(['Attempting to bind ', this.$$linkClassName, ' to ', Class.$name, ' but ', this.$$linkClassName, ' does not contain property ', linkField].join(''));
          }

          // register new linking class for dynamic links
          if (linkField && !LinkClass.$constraints[linkField].domainClass) {
            LinkClass.$constraints[linkField].$$registeredLinks.push(
              {className: Class.$name, method: methodStub, listName: listName}
            );
          }

          // register the relationship
          Class.$$hasMany.push(
            {className: this.$$linkClassName, method: methodStub, listName: listName}
          );

          //console.log('adding relationship to Class ' + Class.name + ' for list ' + listName);
          if (!isFunction(LinkClass)) throw new Error('LinkClass for Class ' + Class.$name + ' must be a constructor function!');
          //console.log('method stub:' + methodStub);

          // Retrieval

          //relationalAccessors(Class, LinkClass, RelationClass, linkCollection, listName, methodStub);
          Class['$getFirst' + methodStub + 'Relation'] = getFirstRelation.bind(this);
          Class.prototype['$getFirst' + methodStub + 'Relation'] = function () {
            return Class['$getFirst' + methodStub + 'Relation'](this.$id);
          };

          Class['$getFirst' + methodStub + 'Item'] = getFirstItem.bind(this);
          Class.prototype['$getFirst' + methodStub + 'Item'] = function () {
            return Class['$getFirst' + methodStub + 'Item'](this.$id);
          };

          Class['$get' + methodStub + 'Relation'] = getRelation.bind(this);
          Class.prototype['$get' + methodStub + 'Relation'] = function () {
            return Class['$get' + methodStub + 'Relation'](this.$id);
          };

          Class['$get' + methodStub + 'RelationRef'] = getRelationRef.bind(this);
          Class.prototype['$get' + methodStub + 'RelationRef'] = function (linkId) {
            return Class['$get' + methodStub + 'RelationRef'](this.$id, linkId);
          };

          Class['$getAll' + methodStub + 'Relations'] = getAllRelations.bind(this);
          Class.prototype['$getAll' + methodStub + 'Relations'] = function () {
            return Class['$getAll' + methodStub + 'Relations'](this.$id);
          };

          Class['$get' + methodStub + 'Relations'] = getRelations.bind(this);
          Class.prototype['$get' + methodStub + 'Relations'] = function () {
            return Class['$get' + methodStub + 'Relations'](this.$id)
          };

          Class['$get' + methodStub + 'List'] = getItems.bind(this);
          Class.prototype['$get' + methodStub + 'List'] = function () {
            return Class['$get' + methodStub + 'List'](this.$id);
          };

          Class['$getAll' + methodStub + 'List'] = getAllItems.bind(this);
          Class.prototype['$getAll' + methodStub + 'List'] = function () {
            return Class['$getAll' + methodStub + 'List'](this.$id);
          };

          //relationalListMethods(Class, listName, methodStub);
          Class['$addTo' + methodStub] = this.addItem.bind(this);
          Class.prototype['$addTo' + methodStub] = function (foreignId, value) {
            return Class['$addTo' + methodStub](this.$id, foreignId, value);
          };

          Class['$removeFrom' + methodStub] = this.removeItem.bind(this);
          Class.prototype['$removeFrom' + methodStub] = function (foreignId) {
            return Class['$removeFrom' + methodStub](this.$id, foreignId);
          };

          if (linkField) {
            bindCollection(Class, LinkClass, linkField, listName, methodStub, this.$$config.belongsTo);
          }
        }

        function bindCollection(Class, LinkClass, linkField, listName, methodStub, belongsTo) {
          // -- Save metadata upward
          LinkClass.$doBeforeSave(function (instance) {
            //console.log(LinkClass.name + '.$doBeforeSave ' + instance.$id);
            //console.log(LinkClass.name + '.$doBeforeSave ' + instance.$id + ' link field:' + linkField + ' value: ' + instance.$$values[linkField]);
            //console.log(' - linked id:' + (instance.$$values[linkField].value && instance.$$values[linkField].value.id));
            //console.log(' - linked collection:' + (instance.$$values[linkField].value && instance.$$values[linkField].value.collection));
            //console.log(' - checking for collection:' + Class.COLLECTION);
            //console.log(' - new check result:' + (!instance.$id && instance.$$values[linkField].value && instance.$$values[linkField].value.collection === Class.COLLECTION));
            if (!instance.$isPersisted() && instance.$$values[linkField].value && instance.$$values[linkField].value.collection === Class.COLLECTION) {
              Object.defineProperty(instance, '$isNew' + Class.$name + linkField, {
                configurable: true,
                value: instance.$$values[linkField].value
              });
            } else {

              // Check for the link having changed so we can update the link collections if appropriate
              if (instance.$$values[linkField].isDirty()) {
                //console.log(LinkClass.name + '.$doBeforeSave ' + instance.$id + ' is dirty');
                //console.log(instance.$$values[linkField].originalValue);
                //console.log(instance.$$values[linkField].value);


                var originalLink = copy(instance.$$values[linkField].originalValue);
                var originalId = originalLink && originalLink.id || null;
                var originalCollection = originalLink && originalLink.collection || null;

                var newLink = copy(instance.$$values[linkField].value);
                var newId = newLink && newLink.id || null;
                var newCollection = newLink && newLink.collection || null;


                if (originalCollection && originalId && originalCollection === Class.COLLECTION && newCollection !== Class.COLLECTION) {

                  //console.log('configuring $isRemoved' + Class.name + linkField + ' with value ', instance.$$values[linkField].originalValue);

                  Object.defineProperty(instance, '$isRemoved' + Class.$name + linkField, {
                    configurable: true,
                    value: originalLink
                  });
                } else if (newCollection && newId && newCollection === Class.COLLECTION && originalCollection !== Class.COLLECTION) {
                  //console.log('$isAdded' + Class.name + linkField + ' - ' + instance.$$values[linkField].toString());
                  Object.defineProperty(instance, '$isAdded' + Class.$name + linkField, {
                    configurable: true,
                    value: newLink
                  });
                } else if (originalId && newId && originalId !== newId && originalCollection === Class.COLLECTION && newCollection === Class.COLLECTION) {
                  //console.log('$isChanged' + Class.name + linkField + ' - ' + instance.$$values[linkField].toString());
                  Object.defineProperty(instance, '$isChanged' + Class.$name + linkField, {
                    configurable: true,
                    value: {originalValue: originalLink, value: newLink}
                  });
                }
              }
            }
          });

          LinkClass.$doAfterSave(function (instance, argsMap) {
            //console.log(LinkClass.name + '.$doAfterSave ' + instance.$id);
            var isNew = '$isNew' + Class.$name + linkField;
            var isAdded = '$isAdded' + Class.$name + linkField;
            var isChanged = '$isChanged' + Class.$name + linkField;
            var isRemoved = '$isRemoved' + Class.$name + linkField;
            var oldLinkClass, newLinkClass, instanceId = instance.$id;
            var value = argsMap[listName] || true;
            var linkDomain, promise;

            //if (instance.$constraints[linkField].type === 'Domain' && instance.$constraints[linkField].domainClass)

            if (instance[isNew]) {
              //console.log('$isNew' + Class.name + linkField + ' - ' + instance.$$values[linkField].toString());
              // If this is a new item, add it to the link collection with the specified value or a default value of true.
              if (instanceId && instance[isNew].id) {
                promise = Class['$addTo' + methodStub](instance[isNew].id, instanceId, value);
                delete  instance[isNew];
                return promise;
              }
              delete  instance[isNew];

            } else if (instance[isAdded]) {
              linkDomain = $domain.getDomain(instance[isAdded].collection); // TODO: need to validate that the method stub is still valid if the collection has changed.  Use the strategy now used on the server to accomplish this
              if (instanceId && instance[isAdded] && instance[isAdded].id) {
                promise = linkDomain['$addTo' + methodStub](instance[isAdded].id, instanceId, value);
                delete  instance[isAdded];
                return promise;
              }
              delete  instance[isAdded];

            } else if (instanceId && instance[isChanged]) { // TODO: may need to improve error handling / production hardening.
              oldLinkClass = $domain.getDomain(instance[isChanged].originalValue.collection);
              newLinkClass = $domain.getDomain(instance[isChanged].value.collection);

              var promiseOld = oldLinkClass['$removeFrom' + methodStub](instance[isChanged].originalValue.id, instanceId);
              var promiseNew = newLinkClass['$addTo' + methodStub](instance[isChanged].value.id, instanceId, value);
              delete instance[isChanged];
              return $q.all([promiseOld, promiseNew]);

            } else if (instance[isRemoved]) {
              oldLinkClass = $domain.getDomain(instance[isRemoved].collection);
              promise = oldLinkClass['$removeFrom' + methodStub](instance[isRemoved].id, instanceId);
              delete instance[isRemoved];
              return promise;

            } else if (!isUndefined(argsMap[listName])) {
              //console.log('updating link data - ' + Class.name + linkField + ' - ' + instance.$$values[linkField].toString(), argsMap[listName]);

              // If a value was specified to save in the relationship, save the link data no matter what.
              if (instanceId && instance.$$values[linkField].originalValue && instance.$$values[linkField].originalValue.id) {
                oldLinkClass = $domain.getDomain(instance.$$values[linkField].originalValue.collection);

                return oldLinkClass['$addTo' + methodStub](instance.$$values[linkField].originalValue.id, instanceId, value);
              }
            }

          });

          // -- End Save metadata upward

          // -- End Update collection references on property change
        }

        return DomainCollection;
      }]
  }
}



// WEBPACK FOOTER //
// ./src/js/_libs/angular-domain/DomainCollection.js